const ITEMS = [
  "Doğal Ahşap",
  "El İşçiliği",
  "Zamansız Tasarım",
  "Sürdürülebilir Üretim",
  "Özenli Detaylar",
  "Ustalıkla Üretim",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-stone-200 bg-beige-soft py-6" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-2xl md:text-3xl text-stone-700 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-wood-light text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
